import {axiosBffFetch} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {SlideStandV3ItemVo} from '../../common/shared/api/nicolas/vo/SlideStandV3ItemVo.interface';

/**
 * 다음 회차 정보 조회
 *
 * Origin: pageNicolasApi.getNextItem
 * API: POST /api/v6/inven/get_next_item
 */
export async function postInvenGetNextItem({
  seriesId,
  productId,
}: {
  seriesId: number;
  productId: number;
}): Promise<ApiResultVo & {item: SlideStandV3ItemVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v6/inven/get_next_item',
    {
      method: 'POST',
      data: {
        seriesPid: seriesId,
        singlePid: productId,
      },
    }
  );
  return response.data;
}
